/**
 * Service: auditTrailVersionHandler
 */
angular.module('acme.common.service.auditTrailVersionHandler', [])
.service('AuditTrailVersionHandlerService', [function() {
    function Version(data) {
      this.auditTrail      =  data.auditTrail           || '';
      this.updatedBy       =  data.auditTrail.updatedBy || '';
      this.updatedAt       =  data.auditTrail.updatedAt || '';
      this.number          =  data.auditTrail.version   ||  0;
      this.tables          =  data.tables               || [];
      this.grids           =  data.grids                || [];
      this.images          =  data.images               || [];
      this.removed         =  data.removed              || [];
      this.diff            =  data.diff                 || {};
      this.original        =  data.previous             || {};
      this.updated         =  data.actual               || {};
      this.gridOptions     =  data.gridOptions          || [];
      this.previousVersion =  data.previousVersion      || null;
      this.nextVersion     =  data.nextVersion          || null;
      this.patchedDiff     =  data.patchedDiff          || {};
      this.rawDiff         =  data.rawDiff              || {};
    }
    return {
      
      version: {},
      
      init: function() {
        return true;
      },
      
      setNewVersion: function (model) {
        this.version = new Version(model);
      },
      
      addToVersion: function (prop, obj) {
        this.version[prop].push(obj);
      },
      
      getVersion: function () {
        return this.version;
      },
      
      reset: function () {
        this.version = {};
      }

    };

}]);